module.exports = __webpack_public_path__ + "static/media/batchnum.9545f58b.svg";